export default function byKey(list, mapper) {
  return Object.fromEntries(list.map(item => [mapper(item), item]))
}
